export const contains = (target, pattern) => {
  let hasAll = true;
  pattern.forEach(function(word) {
    if (!target.toUpperCase().includes(word.toUpperCase())) hasAll = false;
  });
  return hasAll;
};
export const capitalize = (str) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export const genHexString = (size) => {
  const hex = '0123456789ABCDEF';
  let output = '';
  for (let i = 0; i < size; ++i) {
    output += hex.charAt(Math.floor(Math.random() * hex.length));
  }
  return output;
};

export const copyToClibpoard = (string) => {
  if (!navigator.clipboard) {
    const textArea = document.createElement('textarea');
    textArea.value = string;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    document.execCommand('copy');
    document.body.removeChild(textArea);
    return;
  }
  navigator.clipboard.writeText(string);
};

export const pascalToKebabCase = (string) =>
  string.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();

export const pascalToCamelCase = (string) =>
  string.charAt(0).toLowerCase() + string.slice(1);

const clearAndUpper = (string) => string.replace(/-/, '').toUpperCase();

export const kebabToPascalCase = (string) =>
  string.replace(/(^\w|-\w)/g, clearAndUpper);

export const kebabToCamelCase = (string) =>
  string.replace(/-\w/g, clearAndUpper);